import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getBynderAccessToken } from 'packages/store/platform/platform.selectors';
import { getSplitFeatures } from 'packages/store/user/user.selectors';
import { ActiveSplits } from 'packages/store/user/types';
import authService from 'packages/services/authService';

const useDirectAccessToken = () => {
    const bynderAccessToken = useSelector(getBynderAccessToken);
    const splitFeatures = useSelector(getSplitFeatures);
    const isKongGatewayEnabled = splitFeatures?.[ActiveSplits.studioKongGateway] === 'on';
    const [token, setToken] = useState<string>('');

    useEffect(() => {
        if (!bynderAccessToken) {
            setToken('');

            return;
        }

        if (isKongGatewayEnabled) {
            setToken(bynderAccessToken);

            return;
        }

        const updateToken = () =>
            authService
                .getDirectToken(bynderAccessToken)
                .then(setToken)
                .catch((error) => {
                    console.error('Error fetching direct access token:', error);
                    setToken('');
                });

        updateToken();

        // every 5 minutes
        const interval = setInterval(updateToken, 1000 * 60 * 5);

        return () => clearInterval(interval);
    }, [isKongGatewayEnabled, bynderAccessToken]);

    return token;
};

export default useDirectAccessToken;
